import { useContext } from 'react';

import {
  type ModalContextProviderProps,
  ModalContextProvider,
} from './ModalContextProvider.js';
import { ModalContext } from '../contexts/ModalContext.js';

/**
 * Creates a root node that will be aria-hidden if there are modals open.
 */
function OverlayContainerDOM(props: Readonly<ModalContextProviderProps>) {
  const context = useContext(ModalContext);
  const isAriaHidden = context && context.modalCount > 0;
  const modalContextProviderProps = {
    'aria-hidden': isAriaHidden ? true : undefined,
  };
  return (
    <div data-overlay-container {...props} {...modalContextProviderProps} />
  );
}

/**
 * An OverlayProvider acts as a container for the top-level application.
 * Any application that uses modal dialogs or other overlays should
 * be wrapped in a `<OverlayProvider>`. This is used to ensure that
 * the main content of the application is hidden from screen readers
 * if a modal or other overlay is opened. Only the top-most modal or
 * overlay should be accessible at once.
 * @public
 */
export function OverlayProvider(props: Readonly<ModalContextProviderProps>) {
  return (
    <ModalContextProvider>
      <OverlayContainerDOM {...props} />
    </ModalContextProvider>
  );
}
